export function createEventEmitter(opts) {
    const events = [];
    const fetcher = opts.fetcher ?? globalThis.fetch;
    const maxBatch = opts.maxBatch ?? 500;
    const url = opts.baseUrl.replace(/\/$/, '') + '/api/tours/events';
    let timer = null;
    function schedule() {
        if (!timer)
            timer = setTimeout(() => void flush(), opts.batchMs ?? 2000);
    }
    async function flush() {
        const allowed = opts.isAllowed();
        if (timer)
            clearTimeout(timer);
        timer = null;
        if (!events.length || !allowed)
            return;
        const out = events.splice(0, Math.min(events.length, maxBatch));
        try {
            await fetcher(url, {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'x-tenant-id': opts.identity.tenantId,
                    ...(opts.identity.userId ? { 'x-user-id': opts.identity.userId } : {}),
                    ...(opts.identity.deviceId ? { 'x-device-id': opts.identity.deviceId } : {}),
                    ...(opts.identity.app ? { 'x-app-id': opts.identity.app } : {}),
                    ...(opts.identity.platform ? { 'x-platform': opts.identity.platform } : {}),
                    ...(opts.identity.locale ? { 'x-locale': opts.identity.locale } : {}),
                },
                body: JSON.stringify({ events: out }),
                keepalive: true,
            });
        }
        catch {
            // swallow; next push will resend newer events
        }
    }
    function push(e) {
        if (!opts.isAllowed())
            return;
        const nowIso = new Date().toISOString();
        events.push({ ...e, ts: e.ts ?? nowIso });
        schedule();
    }
    function onVisibilityChange() {
        if (typeof document === 'undefined')
            return;
        if (document.visibilityState !== 'visible')
            flush().catch((_e) => {
                void 0;
            });
    }
    if (typeof document !== 'undefined')
        document.addEventListener('visibilitychange', onVisibilityChange);
    return { push, flush };
}
//# sourceMappingURL=emitter.js.map